var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var EuroSign = function (_a) {
    var color = _a.color, className = _a.className, props = __rest(_a, ["color", "className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", className: className }, props),
        React.createElement("path", { fill: color, fillRule: "evenodd", d: "M20.04-0.05C9.02-0.05,0.08,8.88,0.08,19.9s8.94,19.96,19.96,19.96S40,30.93,40,19.9S31.06-0.05,20.04-0.05z\n\t M22.46,15.22v3.37h-8.53c-0.02,0.27-0.03,0.55-0.03,0.82c0,0.28,0.01,0.55,0.03,0.82h8.53v3.37h-7.64\n\tc1.15,2.43,3.28,4.06,5.71,4.06c2.32,0,4.5-1.55,5.7-4.05l3.04,1.46c-1.76,3.68-5.11,5.97-8.74,5.97c-2.73,0-5.27-1.25-7.17-3.52\n\tc-0.95-1.14-1.68-2.47-2.16-3.92H7.53v-3.37h3.02c-0.02-0.27-0.02-0.55-0.02-0.82c0-0.27,0.01-0.55,0.02-0.82H7.53v-3.37h3.66\n\tc0.48-1.45,1.21-2.78,2.16-3.92c1.9-2.27,4.44-3.51,7.17-3.51c3.63,0,6.98,2.29,8.74,5.97l-3.04,1.45c-1.2-2.5-3.38-4.05-5.7-4.05\n\tc-2.43,0-4.55,1.63-5.71,4.06H22.46z" })));
};
EuroSign.defaultProps = {
    className: '',
    color: '#000',
};
export default EuroSign;
//# sourceMappingURL=EuroSign.js.map